/**
 * BaguetteBox RTL Fix
 * 
 * This script fixes the transform values for baguetteBox slider in RTL mode
 * by converting negative translate3d values to positive ones.
 */

const BaguetteBoxRtl = {
    init: function() {
        if (this.isRTL()) {
            this.setupMutationObserver();
            this.fixTransformValues();
        }
    },

    isRTL: function() {
        return document.dir === 'rtl' || 
               document.documentElement.getAttribute('dir') === 'rtl' || 
               document.body.classList.contains('rtl') ||
               document.body.getAttribute('dir') === 'rtl';
    },

    setupMutationObserver: function() {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                // If the slider's transform style changes, fix it
                if (mutation.type === 'attributes' && 
                    mutation.attributeName === 'style' && 
                    mutation.target.id === 'baguetteBox-slider') {
                    this.fixTransformValues();
                }
            });
        });

        const sliderElement = document.getElementById('baguetteBox-slider');
        if (sliderElement) {
            observer.observe(sliderElement, { 
                attributes: true,
                attributeFilter: ['style']
            });
        } else {
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });

            const checkForSlider = setInterval(() => {
                const slider = document.getElementById('baguetteBox-slider');
                if (slider) {
                    clearInterval(checkForSlider);
                    observer.disconnect();
                    observer.observe(slider, { 
                        attributes: true,
                        attributeFilter: ['style']
                    });
                    this.fixTransformValues();
                }
            }, 100);
        }
    },

    fixTransformValues: function() {
        const slider = document.getElementById('baguetteBox-slider');
        if (!slider) return;

        const transform = slider.style.transform;
        if (!transform || !transform.includes('translate3d(')) return;

        const match = transform.match(/translate3d\(([-\d.]+)%,\s*([-\d.]+)px,\s*([-\d.]+)px\)/);
        if (!match) return;

        let xPercent = parseFloat(match[1]);
        if (xPercent < 0) {
            // Convert negative to positive
            xPercent = Math.abs(xPercent);
            slider.style.setProperty('--x-value', `${xPercent}%`);
            slider.style.transform = `translate3d(${xPercent}%, ${match[2]}px, ${match[3]}px)`;
        }
    }
};

document.addEventListener('DOMContentLoaded', function() {
    BaguetteBoxRtl.init();
});

export default BaguetteBoxRtl;
